import { observer } from 'mobx-react';
import React, { useCallback, useEffect } from 'react';
import CusEntInfo from './corp-info';
import CusEntInfoStore from './corp-info-store';
import CardBillListStore from '../card-bill-list/card-bill-list-store';

const CusEntInfoContainer = () => {
  // console.log('CusEntInfoContainer Load');

  const { cusEntInfo } = CusEntInfoStore;
  const {lineNumberList} = CusEntInfoStore

  useEffect(() => {
    // console.log('CorpListContainer > useEffect()');

    CusEntInfoStore.getCusEntInfo();
    CusEntInfoStore.getCusEntLineNumber();
  }, []);

  const onClickAccountInfo = useCallback(async () => {
    CardBillListStore.setVisibleAccountInfoPopup(true);
  }, []);

  const onClickUpdateLineNumber = useCallback(async () => {
    CusEntInfoStore.setVisibleLineNumberPopup(true);
  }, []);

  if (!cusEntInfo) {
    return;
  }

  return (
    <CusEntInfo
      cusEntInfo={cusEntInfo}
      
      onClickAccountInfo={onClickAccountInfo}
      onClickUpdateLineNumber={onClickUpdateLineNumber}
      lineNumberList={lineNumberList}
    />
  );
};

export default React.memo(observer(CusEntInfoContainer));
